export default __webpack_public_path__ + "static/media/terib.66ea8587.png";